import axiosInstance from '../../../lib/axios';
import type { PackageFeatureStatus } from '../types';

export async function listMyFeatures(): Promise<PackageFeatureStatus[]> {
  const response = await axiosInstance.get('/v1/me/features', { skipErrorToast: true });
  return response.data.data;
}
